<template>
  <div>
    <div style="display: flex; justify-content: center; margin: 20px 0;">
      <iframe src="http://119.45.200.53/page/JBrowse/" style="width: 1300px; height: 800px; border-radius: 16px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); border: none; background-color: #fff;"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "JBrowse",
  components: {  },
  // data() {
  //   return {
  //     url: "http://"+this.$store.state.baseurl+":80/page/JBrowse/",
  //   };
  // },
};
</script>

<style scoped></style>